module.exports = __webpack_public_path__ + "img/kt5.b3b3522d.png";